import replaceAndWatchForIframes from './replaceAndWatchForIframes'

export default replaceAndWatchForIframes
